module.exports = __webpack_public_path__ + "img/A2F8_new.65bf8f8f.jpg";